import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-white" data-id="element-113">
      <div className="max-w-3xl mx-auto px-5 md:px-8 text-center" data-id="element-114">
        <div className="flex justify-center mb-6" data-id="element-115">
          <ShieldCheckIcon className="w-16 h-16 text-brand-sage-dark" data-id="element-116" />
        </div>
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-dark mb-4" data-id="element-117">
          Comece Com Segurança
        </h2>
        <p className="text-lg text-brand-text/80 mb-8" data-id="element-118">
          Você recebe acesso imediato ao material e pode começar ainda hoje.
          Siga o protocolo, aplique as orientações e observe como seu corpo
          responde nos primeiros dias.
        </p>
        <div className="bg-brand-cream p-6 rounded-xl border border-brand-sage/30 text-sm text-brand-text/70 italic" data-id="element-119">
          <strong data-id="element-120">Aviso:</strong> Este material é educativo e não substitui
          orientação médica. Caso tenha pressão alta, diabetes, doença renal,
          use medicamentos ou tenha qualquer condição de saúde, consulte seu
          médico antes de iniciar.
        </div>
      </div>
    </section>;
}